import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// normalize
import 'normalize.css/normalize.css'
// 初始化和通用css
import '@/style/common.css';
// element
import 'element-ui/lib/theme-chalk/index.css';
import Element from 'element-ui'
Vue.use(Element);

// 本应用通用css
import '@/style/app.less';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
